import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Modal from '../../../common/modal/Modal';
import {
  getLegalAbandonmentPinPadTransactions,
  postLegalAbandonmentPinPadTransactions,
  putParcelsToPickupByItemLegalAbandonment,
} from '../../../../actions/cargo/CargoPickup';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../config/permissions';
import CargoPickupModalLegalAbandonment from '../cargo-pickup/CargoPickupModalLegalAbandonment';
import { generatePutParcelPickupByItemLegalAbandonment } from '../../../../config/endpoints';
import { flagUsedPinpadTransactions } from '../../../../utils/units/paymentSplit';

const toCents = (value) => Math.round((parseFloat(value) || 0) * 100);

const toPendingPinpadSale = (pendingSale) => ({
  amount: parseFloat(pendingSale.amount) || 0,
  isQrPayment: pendingSale.paymentMethod === 'QR',
  transaction: {
    id: pendingSale.id,
    operation: pendingSale.operation,
    approved: pendingSale.approved,
    responseCode: pendingSale.responseCode,
    financialReference: pendingSale.financialReference,
  },
});

export const DeliverParcelButtonLegalAbandonment = ({
  parcel,
  dispatchPutParcelsToPickupByItemLegalAbandonment,
  dispatchPostLegalAbandonmentPinPadTransactions,
  dispatchGetLegalAbandonmentPinPadTransactions,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const getConsigneeData = () => {
    const { consigneeCustomer, secondaryConsigneeCustomer } = parcel;

    const consigneeCustomerData = {
      value: consigneeCustomer.id || '',
      label:
        `${consigneeCustomer.fullName} | ${consigneeCustomer.identificationType.name}: ${consigneeCustomer.idDocumentNumber}` ||
        '',
    };

    if (!secondaryConsigneeCustomer) {
      return [consigneeCustomerData];
    }

    const secondaryConsigneeCustomerData = {
      value: secondaryConsigneeCustomer.id || '',
      label:
        `${secondaryConsigneeCustomer.fullName} | ${secondaryConsigneeCustomer.identificationType.name}: ${secondaryConsigneeCustomer.idDocumentNumber}` ||
        '',
    };

    return [consigneeCustomerData, secondaryConsigneeCustomerData];
  };

  const onModalSubmit = async ({
    secretCode,
    items,
    deliveredCustomer,
    amountToPay,
    transactionList = [],
    pinPadTransactions = [],
  }) => {
    if (transactionList.length > 1) {
      toastr.error('Error', 'Solo se permite un método de pago');
      return;
    }

    const [transaction] = transactionList;
    const paymentMethod = transaction ? transaction.paymentMethod : null;
    const voucherCode = transaction ? transaction.voucherCode : null;

    if (transaction && toCents(transaction.amount) !== toCents(amountToPay)) {
      toastr.error(
        'Error',
        'El monto del método de pago no coincide con el monto a pagar',
      );
      return;
    }

    await dispatchPutParcelsToPickupByItemLegalAbandonment({
      parcelId: parcel.id,
      secretCode,
      paymentMethod,
      voucherCode,
      items,
      paidAmount: amountToPay,
      deliveredCustomerId: deliveredCustomer.value,
      paymentMethodId: paymentMethod ? paymentMethod.value : null,
      pinPadTransactions: flagUsedPinpadTransactions(
        pinPadTransactions,
        transactionList,
      ),
    });

    setShowModal(false);
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onPinpadTransactionApproved = async (entry) => {
    const persisted = await dispatchPostLegalAbandonmentPinPadTransactions({
      parcelId: parcel.id,
      pinPadTransactions: [entry],
    });
    return persisted && persisted[0] ? persisted[0].id : null;
  };

  const onShowModal = async () => {
    const pendingSales = await dispatchGetLegalAbandonmentPinPadTransactions({
      parcelId: parcel.id,
    });

    if (!pendingSales) {
      return;
    }

    const newModalBody = (
      <CargoPickupModalLegalAbandonment
        parcel={parcel}
        onCancel={onCancel}
        handleProcess={onModalSubmit}
        options={getConsigneeData()}
        onPinpadTransactionApproved={onPinpadTransactionApproved}
        pendingPinpadSales={pendingSales.map(toPendingPinpadSale)}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="success" onClick={onShowModal}>
        <i className="fa fa-plus-circle" /> Entregar Abandono Legal
      </Button>
      <Modal
        show={showModal}
        title="Entregar encomienda sin reclamar"
        onClickClose={() => setShowModal(false)}
        body={modalBody}
        size="lg"
      />
    </>
  );
};

DeliverParcelButtonLegalAbandonment.propTypes = {
  parcel: PropTypes.instanceOf(Object).isRequired,
  dispatchPutParcelsToPickupByItemLegalAbandonment: PropTypes.func.isRequired,
  dispatchPostLegalAbandonmentPinPadTransactions: PropTypes.func.isRequired,
  dispatchGetLegalAbandonmentPinPadTransactions: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutParcelsToPickupByItemLegalAbandonment:
    putParcelsToPickupByItemLegalAbandonment,
  dispatchPostLegalAbandonmentPinPadTransactions:
    postLegalAbandonmentPinPadTransactions,
  dispatchGetLegalAbandonmentPinPadTransactions:
    getLegalAbandonmentPinPadTransactions,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(DeliverParcelButtonLegalAbandonment);

export default withEndpointAuthorization({
  url: generatePutParcelPickupByItemLegalAbandonment(0),
  permissionType: PUT,
})(connectedComponent);
